export default __webpack_public_path__ + "static/media/1592.b3338595.png";